import Alpine from 'alpinejs';
import Hammer from 'hammerjs';
import intersect from '@alpinejs/intersect';
Alpine.plugin(intersect);

document.addEventListener("alpine:init", () => {

	Alpine.data('hero', ( initColor = 'dark-blue' ) => ({
		isLoading: true,
		isChanging: false,
		slides: null,
		currentColor: initColor,
		colors: [],
		current: 0,
		next: 0,
		total: 1,
		timeout: 500,
		autoplayInterval: 5000,
		timer: null,
		reverseColors: [
			'dark-blue',
			'green',
			'purple'
		],
		init() {
			
			this.slides = this.$refs.carousel.querySelectorAll('.slide');
			
			// get all the colours into an array
			this.total = this.slides.length;
			this.slides.forEach((slide, index) => {
				this.colors.push( slide.dataset.color );
			});
			
			
			this.startAutoplay();

			// Add hammerjs for swipe event support
			new Hammer( this.$refs.carousel ).on('swipeleft swiperight', function(ev) {
				if( ev.type == 'swipeleft' ){
					this.nextSlide();
				}else{
					this.prevSlide();
				}
			}.bind(this));

			this.isLoading = false;
		},

		startAutoplay() {
			this.timer = setInterval(() => {
				this.nextSlide();
			}, this.autoplayInterval);
		},
  
		stopAutoplay() {
			clearInterval(this.timer);
		},
  
		resetAutoplay() {
			this.stopAutoplay();
			this.startAutoplay();
		},

		// fadeout
		changeColor() {
			// just for container class
			const newColor = `theme-${ this.currentColor }`;
			this.$refs.wrapper.className = 'intro-slider';
			this.$refs.wrapper.classList.add(newColor);

			// change header color
			if( !this.reverseColors.includes(this.currentColor) ){
				document.querySelector('.site-header').classList.add('dark-text');
			}else{
				document.querySelector('.site-header').classList.remove('dark-text');
			}
		},

		nextSlide() {
			if( this.current == ( this.total - 1 ) ){
				this.changeSlide(0);
			}else{
				this.changeSlide( this.current + 1 );
			}
		},

		prevSlide() {
			if( this.current == 1 ){
				this.changeSlide( this.total - 1 );
			}else{
				this.changeSlide( this.current - 1 );
			}
		},

		async changeSlide( nextItem ) {
			// console.log(nextItem);

			if( nextItem === this.current ){
				return;
			}
			
			this.next = nextItem;
			this.isChanging = true;

			const current = await new Promise((resolve) => {
				setTimeout(() => {
					resolve(this.next);
				}, this.timeout);
			});

			this.current = nextItem;
			this.currentColor = this.colors[ this.current ];
			

			setTimeout(() => {
				this.changeColor();
				this.isChanging = false;
			}, this.timeout / 2);

			setTimeout(() => {
				this.resetAutoplay();
			}, this.timeout);

		}
	}));

});